<!-- 滚动组件 -->
<template>

    <div id="boxFixed" :style="{height:offsetHeight+'px'}">
      <slot></slot>
    </div>

</template>

<script>
export default {
  data () {
    return {
      is_bottom: false,
      is_top: false,
      scrollTop: null
    };
  },

  components: {},

  computed: {
    offsetHeight () {
      return document.documentElement.offsetHeight
    }
  },
  mounted () {
    document.querySelector('#boxFixed').addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    // 离开这个界面之后，删除滚动事件，不然容易除bug
    // document.removeEventListener('#boxFixed').addEventListener('scroll', this.handleScroll)

  },
  methods: {
    handleScroll () {
      this.is_top = false
      this.is_bottom = false
      let dom = document.querySelector('#boxFixed')
      let scrollTop = dom.scrollTop // 滚动条偏移量
      this.scrollTop = scrollTop
      //   console.log('偏移量：' + scrollTop, '最大偏移量：' + (dom.scrollHeight - dom.offsetHeight))// 内容总高度 - 一屏的高度=最底部偏移量
      if (scrollTop === dom.scrollHeight - dom.offsetHeight) {
        this.is_bottom = true
        this.arrive_bottom()
      } else if (scrollTop === 0) {
        this.is_top = true
        this.arrive_top()
      }
    },
    arrive_top () {
      // console.log('最顶部', this.is_top)
    },
    arrive_bottom () {
    //   console.log('最底部', this.is_bottom)
    },

    go (to, time, back) { // this.go('滚动位置','滚动间隔','回调函数')
      var _to = Number(to) || 0
      var _time = time || 1
      var _back = back || function () { };
      var dom = document.querySelector('#boxFixed')
      var scrollTop = dom.scrollTop // 滚动条偏移量

      var onceTo = 3
      for (let index = 0; index < Math.abs((scrollTop - _to) / onceTo); index++) {
        setTimeout(() => {
          dom.scrollTo(0, Math.abs(scrollTop - onceTo * index));
          // console.log(dom.scrollTop ,_to);
          if (scrollTop === _to) {
            console.log('已到指定点')
            _back()
          }
        }, _time * index);
      }
    }
  }
}

</script>
<style scoped>
#boxFixed {
  width: 100%;
  height: 100vh;
  background: #fff;
  overflow: overlay;
}
</style>
